export default __webpack_public_path__ + "static/img-slider-03-2a86a538a7d9912dc626f3348d682ecf.png";